// extracted by mini-css-extract-plugin
export default {"container":"OrderClose_container__P6GZL","card":"OrderClose_card__mhcvQ"};